import { Grid, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { TextFieldCustom } from "./TextFieldCustom";
import TextFieldWithButtons from "./TextFieldWithButtons/TextFieldWithButtons";

type OwnProps = {
    label: string;
    max: number;
    min: number;
    initialValue: number;
    onChange: (value: number) => void;
    maxAfterBlur?: number
};

export const TextFieldWithLabel = memo(({ label, max, maxAfterBlur, min, initialValue, onChange }: OwnProps) => {
    const [value, setValue] = useState<number>(initialValue);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(Number(event.target.value));
        onChange(Number(event.target.value));
    };

    useEffect(() => {
        initialValue && setValue(initialValue);
    }, [initialValue]);

    const handleBlur = () => {
        if (value < min) {
            setValue(min);
            onChange(min);
        } else if (value > max) {
            onChange(max);
            setValue(max);
        }
    };

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item width={"150px"}>
                <Typography variant="overline" color="text.secondary">
                    {label}
                </Typography>
            </Grid>

            <Grid item>
                <TextFieldWithButtons
                    hideButtons={true}
                    min={min}
                    max={max}
                    maxAfterBlur={maxAfterBlur}
                    isEval={true}
                    objValue={value}
                    setObjValue={onChange}
                    inputProps={{
                        style: {
                            width: "95px",
                        },
                    }}
                />
            </Grid>
        </Grid>
    );
});
